<template>
    <app-layout title="Create Load">
        <form @submit.prevent="handleSubmit">
            <page-header>
                <template #title>Create Load</template>

                <template #actions>
                    <jet-button v-show="form.isDirty" type="submit" class="leading-none" :disabled="form.processing" >
                        Save
                    </jet-button>

                    <jet-tertiary-button
                        v-if="form.isDirty"
                        :disabled="form.processing"
                        class="leading-none"
                        @click="showUnsavedChangesModal = true"
                    >
                        Cancel
                    </jet-tertiary-button>

                    <jet-tertiary-button
                        v-else
                        :disabled="form.processing"
                        :href="route('loads.index')"
                        class="leading-none"
                    >
                        Close
                    </jet-tertiary-button>
                </template>
            </page-header>

            <load-form
                :form="form"
                :locations="locations"
                class="px-3 md:px-4 lg:px-8"
            />
        </form>

        <unsaved-changes-modal-2
            :formRoute="formRoute"
            :isDirty="form.isDirty"
            :show="showUnsavedChangesModal"
            @close="showUnsavedChangesModal = false"
            @confirm="$inertia.get(backUrl)"
        />
    </app-layout>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import LoadForm from '@/Pages/Loads/Partials/LoadForm.vue';
import JetButton from '@/Jetstream/Button';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import JetConfirmationModal from '@/Jetstream/ConfirmationModal';
import UnsavedChangesModal2 from '@/Shared/UnsavedChangesModal2';
import { DateTime } from 'luxon';

export default {
    setup() {
        const form = useForm({
            id: null,
            date: new Date(),
            route_type: null,
            route: null,
            truck: null,
            driver: null,
            departure_time: null,
            order_numbers: null,
            type: null,
            location_id: null,
            shipping_time: null,
        })

        return { form }
    },

    props: [
        'locations',
    ],

    components: {
        AppLayout,
        PageHeader,
        LoadForm,
        JetButton,
        JetTertiaryButton,
        JetConfirmationModal,
        UnsavedChangesModal2,
    },

    data() {
        return {
            formRoute: this.route('loads.store'),
            showUnsavedChangesModal: false,
        }
    },

    methods: {
        handleSubmit () {
            if(!this.form.processing){
                this.form
                    .transform((data) => ({
                        ...data,
                        date: data.date ? this.formatDate(data.date) : null,
                    }))
                    .post(route('loads.store'));
            }
        },

        formatDate (date) {
            return DateTime.fromJSDate(date).toSQLDate();
        },
    },

    computed: {
        backUrl () {
            const params = route().params;

            if (params.return) {
                return params.return;
            }

            return route('loads.index', {
                page: this.$page.props.page.orders,
            });
        },
    },
}
</script>

<style scoped>
.multi-custom {
    min-height: 1.5rem;
}
</style>
